// @ts-nocheck
import { useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Label } from './ui/label';
import { Input } from './ui/input';
import { FileText, Loader2 } from 'lucide-react';
import { supabase } from '@product-radar/shared';
import { toast } from 'sonner';

interface LinkJiraTicketDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  workspaceId: string;
  ideaId: string;
  onSuccess?: () => void;
}

export function LinkJiraTicketDialog({ open, onOpenChange, workspaceId, ideaId, onSuccess }: LinkJiraTicketDialogProps) {
  const [jiraInput, setJiraInput] = useState('');
  const [linking, setLinking] = useState(false);

  const handleLink = async () => {
    const trimmed = jiraInput.trim();
    if (!trimmed) {
      toast.error('Enter a Jira URL or ticket key');
      return;
    }
    setLinking(true);
    try {
      const { data, error } = await supabase.functions.invoke('jira-fetch-issue', {
        body: {
          workspace_id: workspaceId,
          idea_id: ideaId,
          jira_input: trimmed,
        },
      });
      if (error) throw error;
      if (data?.ok === false) throw new Error(data?.error || data?.details);
      toast.success('Linked', { description: `${data?.jira_key} ${data?.jira_status ? `(${data.jira_status})` : ''}` });
      setJiraInput('');
      onSuccess?.();
      onOpenChange(false);
    } catch (e: any) {
      toast.error('Failed to link', { description: e?.message });
    } finally {
      setLinking(false);
    }
  };

  const handleOpenChange = (v: boolean) => {
    if (!v) setJiraInput('');
    onOpenChange(v);
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-3 mb-1">
            <div className="p-2 bg-muted rounded-lg">
              <FileText className="h-6 w-6" />
            </div>
            <div>
              <DialogTitle>Link existing Jira ticket</DialogTitle>
              <DialogDescription>Paste the Jira URL or ticket key (e.g. PROJ-123).</DialogDescription>
            </div>
          </div>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label>Jira URL or key</Label>
            <Input
              placeholder="https://company.atlassian.net/browse/PROJ-123 or PROJ-123"
              value={jiraInput}
              onChange={(e) => setJiraInput(e.target.value)}
            />
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => handleOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={handleLink} disabled={linking || !jiraInput.trim()}>
            {linking ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null}
            Link
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
